var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventKwai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.55835)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.5583,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#FFD8AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3093 66.7458H58.8217C59.4264 66.7458 60.0252 66.6238 60.5838 66.3867C61.1424 66.1497 61.65 65.8022 62.0775 65.3641C62.5051 64.9261 62.8442 64.4061 63.0755 63.8338C63.3068 63.2615 63.4258 62.6481 63.4257 62.0287V55.2352C63.4258 54.6158 63.3068 54.0024 63.0755 53.4301C62.8442 52.8578 62.5051 52.3378 62.0775 51.8997C61.65 51.4617 61.1424 51.1142 60.5838 50.8772C60.0252 50.6401 59.4264 50.5181 58.8217 50.5181H47.3093C46.7047 50.5181 46.106 50.6401 45.5474 50.8771C44.9888 51.1141 44.4813 51.4615 44.0538 51.8994C43.6263 52.3374 43.2871 52.8573 43.0558 53.4295C42.8244 54.0017 42.7053 54.615 42.7053 55.2343V62.0287C42.7052 62.6481 42.8242 63.2615 43.0555 63.8338C43.2869 64.4061 43.626 64.9261 44.0535 65.3641C44.481 65.8022 44.9886 66.1497 45.5472 66.3867C46.1059 66.6238 46.7046 66.7458 47.3093 66.7458Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1551 45.582C48.8163 45.582 51.7843 42.5416 51.7843 38.7911C51.7843 35.0406 48.8163 32.0002 45.1551 32.0002C41.4939 32.0002 38.5259 35.0406 38.5259 38.7911C38.5259 42.5416 41.4939 45.582 45.1551 45.582Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6056 45.581C60.8205 45.581 63.4267 42.9113 63.4267 39.6179C63.4267 36.3246 60.8205 33.6548 57.6056 33.6548C54.3906 33.6548 51.7844 36.3246 51.7844 39.6179C51.7844 42.9113 54.3906 45.581 57.6056 45.581Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57.0002L36.3028 54.0637C35.2795 53.4582 34 54.2151 34 55.4252V61.8591C34 63.0692 35.2795 63.8261 36.3028 63.2206L42 60.0002",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventKwai);
export default __webpack_public_path__ + "static/media/canvas_event_kwai.6999ae4dd25f3969538ef44ca128971d.svg";
export { ForwardRef as ReactComponent };